<template>
  <div class="dflexc-jcs" id="num-pad-panel">
    <NumPadDisplay :displayVal="display"/>
    <NumPadBtnPanel @btn-pressed="(btn) => update_display(btn)"/>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/styles/numpad/sm.scss';
  @import '@/assets/styles/numpad/md.scss';
  @import '@/assets/styles/numpad/lg.scss';
  @import '@/assets/styles/numpad/xlg.scss';

</style>

<script setup>
import {onMounted, onUpdated, ref, watch} from "vue";

import NumPadDisplay from '../numpad/num_pad_display.vue'
import NumPadBtnPanel from '../numpad/num_pad_btn_panel.vue'

const props = defineProps(['store', 'display_val'])
const emit = defineEmits(['genResults', 'generate'])
const display = ref('0')

const forcedis = ref(false)

// store will be either jewels or debris
const genStore = props.store
let tmpEle = document.getElementById('dice_results_view')

// watch(forcedis.value, () => {
//   debugger
//   display.value = prep_display
// } )

onMounted(() => {
  display.value = '0'
})

onUpdated(() => {
  if(props.display_val !== undefined &&
      props.display_val !== '0') {
    display.value = props.display_val
  }

  // if(forcedis.value) {
  //   forcedis.value = false
  //   display.value = prep_display
  // }

})

function update_display(val) {

  if (val === 'Clr') {
    display.value = '0'
  } else if (val === 'Del') {
    if (display.value === '0')
      return
    display.value = display.value.substring(0, display.value.length - 1)
    if (display.value === '')
      display.value = '0'
  } else if (val === 'Roll') {
    if(display.value === '0')
      return
    emit('generate', display.value)
  } else if(val === ' ') {
    // do nothing yet
  } else {
    if (display.value === '0' || display.value === undefined) {
      display.value = val
    } else {
      display.value = display.value + val
    }

  }
  // display.value = display
  // forcedis.value = true
}

function generate() {
  genStore.roll(parseInt(display))
  emit('genResults')
}

</script>
